import React from "react";
import StatCard from "../Components/StatCard";
import SectionLabel from "../Components/SectionLabel";
import StatGrid from "../Components/statGrid";

/**
 * ClaimsTab
 *
 * Props:
 *   data — { totalUserClaimed, totalClaimed, totalClaimedSuccess,
 *            totalClaimedProcessing, totalClaimedRejected, totalClaimedFailed }
 */
const ClaimsTab = ({ data = {} }) => {
  const total = data?.totalClaimed || 0;

  const successRate =
    total > 0 ? ((data?.totalClaimedSuccess / total) * 100).toFixed(1) : "0.0";
  const processingRate =
    total > 0
      ? ((data?.totalClaimedProcessing / total) * 100).toFixed(1)
      : "0.0";
  const rejectedRate =
    total > 0 ? ((data?.totalClaimedRejected / total) * 100).toFixed(1) : "0.0";
  const failedRate =
    total > 0 ? ((data?.totalClaimedFailed / total) * 100).toFixed(1) : "0.0";

  return (
    <>
      {/* ── Summary ── */}
      <SectionLabel>Claims overview</SectionLabel>
      <StatGrid>
        <StatCard
          label="Total claims"
          value={data?.totalClaimed}
          sub="All time claims"
          accent="blue"
        />
        <StatCard
          label="Users claimed"
          value={data?.totalUserClaimed}
          sub="Unique users who claimed"
          accent="purple"
        />
      </StatGrid>

      {/* ── Status breakdown ── */}
      <SectionLabel>Claims by status</SectionLabel>
      <StatGrid>
        <StatCard
          label="Successful"
          value={data?.totalClaimedSuccess}
          sub={`${successRate}% of total`}
          accent="green"
        />
        <StatCard
          label="Processing"
          value={data?.totalClaimedProcessing}
          sub={`${processingRate}% of total`}
          accent="amber"
        />
        <StatCard
          label="Rejected"
          value={data?.totalClaimedRejected}
          sub={`${rejectedRate}% of total`}
          accent="coral"
        />
        <StatCard
          label="Failed"
          value={data?.totalClaimedFailed}
          sub={`${failedRate}% of total`}
          accent="red"
        />
      </StatGrid>
    </>
  );
};

export default ClaimsTab;
